/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */

import React, {useContext} from 'react';
import {UploadClient} from './UploadClient';

const UploadClientContext = React.createContext(new UploadClient());

export const UploadClientProvider = UploadClientContext.Provider;

export function useUploadClient(): UploadClient {
  return useContext(UploadClientContext);
}
